module.exports = __webpack_public_path__ + "img/DesertJewel_EGM.24b5631d.jpg";